export const credits = [
  {
    role: "Producer / Director",
    title: "Neighbourhood Watch",
    channel: "HGTV",
    company: "Arrow Media",
    date: "Nov 25 - Feb 26",
    commissioner: "",
    category: "Recent Credits",
    image: "/images/work-neighborhoodwatch.jpg",
    synopsis:
      "Light-hearted comedy based, factual entertainment series feauturing funny moments caught on doorbell and home security cameras.",
  },
  {
    role: "Producer / Director",
    title: "5 Days that Brought Down Prince Andrew",
    channel: "Channel 5",
    company: "Mentorn Media",
    date: "Oct 25 - Oct 25",
    commissioner: "Federico Ruiz",
    category: "Recent Credits",
    image: "/images/work-5days.jpeg",
    synopsis:
      "Fast-turnaround premium documentary examining the events and revelations around the Prince Andrew story. This documentary contributed directly to Andrew Mountbatten-Windsor's title of 'Prince' being removed by the King",
  },
  {
    role: "PD / Edit Producer",
    title: "Prince Andrew and the Epstein Email Scandal",
    channel: "Channel 5",
    company: "Mentorn Media",
    date: "Oct 25 - Oct 25",
    commissioner: "Federico Ruiz",
    category: "Recent Credits",
    image: "/images/work-andrew.png",
    synopsis:
      "Topical interview and archive-led documentary featuring sensitive subject matter, revelations and NDA based content. Fast turnaround storytelling and edit producing.",
  },
  {
  role: "PD / Self-Shooting",
  title: "At War with Next Door",
  channel: "Channel 5",
  company: "Kalel Productions",
  date: "Sep 25 – Nov 25",
  commissioner: "Federico Ruiz",
  category: "Recent Credits",
  image: "/images/work-awwnd.png",
  synopsis:
    "Contributor-led factual series built around neighbourhood disputes, access and unfolding actuality.",
},
{
  role: "Series Director",
  title: "Murder in Mind",
  channel: "CBS Reality",
  company: "Back2Back",
  date: "Jan 25 – Jul 25",
  commissioner: "Sam Rowden",
  category: "Recent Credits",
  image: "/images/work-MIM.png",
  synopsis:
    "True crime series requiring careful story structure, sensitive contributor handling and editorial oversight across episodes. Examination into the psychology of extreme criminal behaviour",
},
{
  role: "Series Director",
  title: "Killers Caught on Camera",
  channel: "CBS Reality",
  company: "Back2Back",
  date: "Aug 24 – Jan 25",
  commissioner: "Sam Rowden",
  category: "Recent Credits",
  image: "/images/work-kcoc.jpg",
  synopsis:
    "True crime series shaped around evidence, testimony and archive, with a focus on clear narrative progression and compliance-aware storytelling.",
},
{
  role: "PD / Edit Producer",
  title: "Bodycam",
  channel: "Discovery ID",
  company: "Arrow International Media",
  date: "2023/2024",
  commissioner: "",
  category: "Recent Credits",
  image: "/images/work-bodycam.webp",
  synopsis:
    "High-intensity factual crime series combining actuality, archive, contributor testimony and precise edit structure.",
},
{
  role: "Preditor",
  title: "Tom Cruise: The Last Movie Star",
  channel: "Amazon Prime",
  company: "Spiritlevel Cinema",
  date: "Feb 23 – May 23",
  commissioner: "",
  category: "Recent Credits",
  image: "/images/work-cruise.jpg",
  synopsis:
    "Feature documentary work combining archive, film history and authored documentary storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "Teacher With Tourette's",
  channel: "Channel 5",
  company: "Viacom International Studios UK",
  date: "Dec 22 – Dec 22",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-teacher.jpg",
  synopsis:
    "Provided additional filming for sensitive factual documentary work with contributor-led storytelling and duty of care.",
},
{
  role: "PD / Self-Shooting",
  title: "Secrets of the Royal Palaces",
  channel: "Channel 5",
  company: "Viacom International Studios UK",
  date: "Jul 22 – Jul 22",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-secretsroyal.png",
  synopsis:
    "History and heritage documentary filming, combining location material, expert contributors and archive-led storytelling.",
},
{
  role: "PD / Edit Producer",
  title: "Bodycam",
  channel: "Discovery ID",
  company: "Arrow International Media",
  date: "Jun 22 – Dec 22",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-bodycam02.jpg",
  synopsis:
    "Crime documentary work across production and post, shaping complex real-life incidents into clear, compelling episode narratives.",
},
{
  role: "PD / Self-Shooting",
  title: "Building the Impossible",
  channel: "Channel 5",
  company: "October Films",
  date: "Jun 22 – Jun 22",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-bti.png",
  synopsis:
    "Specialist factual filming focused on engineering, scale, process and visually led storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "Camilla's Country Life",
  channel: "ITV",
  company: "Spun Gold TV",
  date: "May 22 – Jun 22",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-camilla.jpg",
  synopsis:
    "Self-shot factual filming with access, location sequences and contributor-led material.",
},
{
  role: "PD / Self-Shooting",
  title: "Terry Wogan: Now You're Talking",
  channel: "Channel 5",
  company: "Viacom International Studios UK",
  date: "Nov 21 – Dec 21",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-wogan.png",
  synopsis:
    "Archive-led profile documentary drawing on interviews, clips and popular culture history.",
},
{
  role: "PD / Self-Shooting",
  title: "Greatest Pop Videos of the 80s and 90s",
  channel: "Channel 5",
  company: "Viacom International Studios UK",
  date: "Jan 22 – May 22",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-popvideos.png",
  synopsis:
    "Popular music documentary work combining archive, contributors and authored entertainment storytelling.",
},
{
  role: "PD / Edit Producer",
  title: "Hollywood Icons: Brad Pitt",
  channel: "Channel 5",
  company: "Viacom International Studios UK",
  date: "Sep 21 – Nov 21",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-hollywoodicons2.jpg",
  synopsis:
    "Profile documentary combining archive, interviews and film history to tell a star-led narrative.",
},
{
  role: "Edit Producer",
  title: "Secrets of the Royal Palaces",
  channel: "Channel 5",
  company: "Viacom International Studios UK",
  date: "Aug 21 – Sep 21",
  commissioner: "Greg Barnett",
  category: "Broadcast Credits",
  image: "/images/work-scrtsroyal.jpg",
  synopsis:
    "History and heritage documentary series shaped through archive, expert testimony and location-led storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show Film Team",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Jul 21 – Aug 21",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-theoneshow.jpg",
  synopsis:
    "Self-shot topical factual films for BBC One, requiring fast turnaround, strong contributor handling and clear story beats.",
},
{
  role: "PD / Self-Shooting",
  title: "Sunday Morning Live",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Jun 21 – Jul 21",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-sundaymorning.jpg",
  synopsis:
    "Topical factual filming for BBC One, balancing contributor-led material with clear editorial purpose.",
},
{
  role: "PD / Self-Shooting",
  title: "Morning Live",
  channel: "BBC One",
  company: "BBC Documentaries",
  date: "Jan 21 – Jun 21",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-morninglive.jpg",
  synopsis:
    "Daytime factual films and topical items produced and shot for BBC One.",
},
{
  role: "Edit Producer",
  title: "Hampton Court: Behind Closed Doors",
  channel: "Channel 5",
  company: "Lion Television",
  date: "Oct 20 – Nov 20",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-hamptonct.jpg",
  synopsis:
    "History and access documentary series shaped in the edit, combining heritage, contributors and archive-led storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "Inside the Tower of London: Series 3",
  channel: "Channel 5",
  company: "Lion Television",
  date: "Feb 20 – Sep 20",
  commissioner: "Lucy Willis",
  category: "Broadcast Credits",
  image: "/images/work-insidetower.jpg",
  synopsis:
    "Access-led history series filmed at one of Britain's most recognisable heritage locations, combining actuality, contributors and historical storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show Film Team",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Aug 19 – Jan 20",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-theoneshow.jpg",
  synopsis:
    "Self-shot BBC One factual films, covering a range of human interest, topical and specialist stories.",
},
{
  role: "PD / Self-Shooting",
  title: "Then & Now: Motorway Britain – 60 Years of Speed",
  channel: "Channel 5",
  company: "Viacom Studios",
  date: "Jun 19 – Aug 19",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-thenandnow2.jpg",
  synopsis:
    "History and social documentary looking at Britain’s motorway network through archive, contributors and location filming.",
},
{
  role: "PD / Edit Producer",
  title: "Inside the Factory",
  channel: "BBC Two",
  company: "Voltage TV Productions",
  date: "Jan 19 – May 19",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-factory03.jpg",
  synopsis:
    "Specialist factual series combining process, scale and story, with filming and edit producing across factory-led sequences.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show Film Team",
  channel: "BBC One",
  company: "BBC Studios",
  date: "May 18 – Nov 18",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-theoneshow.jpg",
  synopsis:
    "Self-shot BBC One factual films across topical, human interest and specialist subjects.",
},
{
  role: "PD / Self-Shooting",
  title: "Secrets of the Bermuda Triangle",
  channel: "Channel 5",
  company: "BBC Studios",
  date: "Mar 18 – May 18",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-bermudacard.jpg",
  synopsis:
    "Specialist factual documentary exploring mystery, science and history through location filming, contributors and archive.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show Film Team",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Nov 17 – Mar 18",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-tos06.jpg",
  synopsis:
    "Self-shot BBC One factual films, producing concise, character-led stories for a broad audience.",
},
{
  role: "PD / Edit Producer",
  title: "Wartime Crime",
  channel: "Discovery",
  company: "Symmetrica",
  date: "Jun 17 – Oct 17",
  commissioner: "Ron Simon",
  category: "Broadcast Credits",
  image: "/images/work-wartimecrime.jpg",
  synopsis:
    "History and crime documentary series combining archive, testimony and investigation-led storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show Film Team",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Jan 17 – Jan 17",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-tos03.jpg",
  synopsis:
    "Self-shot factual films for BBC One, producing concise, character-led stories for a broad audience.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show: Science Inserts",
  channel: "BBC One",
  company: "BBC Studios",
  date: "May 17 – Jun 17",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-tosscience.jpg",
  synopsis:
    "Specialist factual and science inserts for BBC One, translating complex subjects into accessible short films.",
},
{
  role: "PD / Self-Shooting",
  title: "Coast vs Country: Series 2",
  channel: "Channel 4",
  company: "Freeform",
  date: "Feb 17 – May 17",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-coastvcountry.jpg",
  synopsis:
    "Lifestyle and property factual series, filming contributors and location-led stories across the UK.",
},
{
  role: "PD / Self-Shooting",
  title: "Shell Eco-marathon",
  channel: "",
  company: "Bigger Bang TV",
  date: "Dec 16 – Dec 16",
  commissioner: "",
  category: "Branded / Specialist Factual",
  image: "/images/work-shell.jpg",
  synopsis:
    "Branded specialist factual filming around engineering, innovation and competition.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show: History Inserts",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Sep 16 – Oct 16",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-tos04.jpg",
  synopsis:
    "History inserts for BBC One, combining archive, location filming and accessible storytelling.",
},
{
  role: "PD / Self-Shooting",
  title: "The One Show Film Team",
  channel: "BBC One",
  company: "BBC Studios",
  date: "Feb 16 – Jul 16",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-tos02.jpg",
  synopsis:
    "Self-shot, fast turnaround topical and human-interest factual films for BBC's The One Show.",
},
{
  role: "Editor",
  title: "Ex-Dominatrix: A True Story",
  channel: "",
  company: "Darren Cavenagh",
  date: "Nov 15 – Jan 16",
  commissioner: "",
  category: "Editing Credits",
  image: "/images/work-exdom.jpg",
  synopsis:
    "Documentary editing work on a character-led personal story.",
},
{
  role: "PD / Self-Shooting",
  title: "Bake Off: Creme de la Creme",
  channel: "BBC Two",
  company: "Love Productions",
  date: "Sep 15 – Oct 15",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-bakeoffcdlc.jpg",
  synopsis:
    "Self-shot factual entertainment filming for a high-profile BBC Two competition format.",
},
{
  role: "PD / Edit Producer",
  title: "The One Show",
  channel: "BBC One",
  company: "BBC Studios",
  date: "May 15 – Aug 15",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-tos05.jpg",
  synopsis:
    "Producing, shooting and edit producing fast turnaround, short-form factual films for BBC One.",
},
{
  role: "Editor",
  title: "Clare Balding Show",
  channel: "BT Sport",
  company: "Boomerang",
  date: "Nov 14 – Nov 14",
  commissioner: "",
  category: "Editing Credits",
  image: "/images/work-clarebalding.jpg",
  synopsis:
    "Avid editing work for a studio-based sports entertainment series.",
},
{
  role: "Editor",
  title: "ICC Cricket World Cup Highlights",
  channel: "",
  company: "Aurora Media Worldwide",
  date: "Apr 15 – Apr 15",
  commissioner: "",
  category: "Editing Credits",
  image: "/images/work-cricket.png",
  synopsis:
    "Fast-turnaround sports highlights editing for international cricket coverage.",
},
{
  role: "Editor",
  title: "The Stig Joins YouTube",
  channel: "YouTube",
  company: "BBC Worldwide",
  date: "Dec 14 – Dec 14",
  commissioner: "",
  category: "Editing Credits",
  image: "/images/work-stig.png",
  synopsis:
    "Editing work for BBC Worldwide digital content.",
},
{
  role: "DV Director",
  title: "Holiday of My Lifetime with Len Goodman",
  channel: "BBC One",
  company: "Raise the Roof Productions",
  date: "Aug 14 – Sep 14",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-homllen.jpg",
  synopsis:
    "DV directing on contributor-led factual entertainment for BBC One.",
},
{
  role: "Location Director",
  title: "The Munch Box",
  channel: "ITV",
  company: "Cactus TV",
  date: "Jun 14 – Sep 14",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-munchbox.png",
  synopsis:
    "Location directing for ITV factual entertainment, working with contributors and format-led sequences.",
},
{
  role: "Editor",
  title: "Al Murray's Great British War Movies",
  channel: "BBC Two",
  company: "Liberty Bell",
  date: "Aug 14 – Aug 14",
  commissioner: "",
  category: "Editing Credits",
  image: "/images/work-almurray.jpg",
  synopsis:
    "Avid editing work on a BBC Two history and entertainment documentary special.",
},
{
  role: "DV Director",
  title: "Saturday Kitchen",
  channel: "BBC One",
  company: "Cactus TV",
  date: "Feb 14 – Jan 16",
  commissioner: "",
  category: "Broadcast Credits",
  image: "/images/work-satkitch.jpg",
  synopsis:
    "DV directing for BBC One’s long-running food and lifestyle format.",
},
{
  role: "Producer / Director",
  title: "Twilight: The Robert Pattinson and Taylor Lautner Saga",
  channel: "",
  company: "Entertain Me Group",
  date: "Jul 12 – Sep 12",
  commissioner: "Brian Arbech",
  category: "Music / Entertainment Documentary",
  image: "/images/work-patlaut.jpg",
  synopsis:
    "Entertainment documentary profiling the stars and cultural impact of the Twilight franchise.",
},
{
  role: "Editor",
  title: "Ginx TV eSports: Reviews and Online Shows",
  channel: "Ginx TV",
  company: "",
  date: "Jun 11 – Apr 12",
  commissioner: "Stefan Eriksson",
  category: "Editing Credits",
  image: "/images/work-ginx.png",
  synopsis:
    "Editing work across games, eSports, reviews and online entertainment content.",
},
{
  role: "Producer / Director",
  title: "The Roaring 20s: Mick Jagger's Glory Years",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Jan 11 – Feb 11",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-jagger.jpg",
  synopsis:
    "Archive-led music documentary exploring Mick Jagger’s career and cultural impact.",
},
{
  role: "Producer / Director",
  title: "Here We Are in the Years: Neil Young's Music Box",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Oct 10 – Dec 10",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-neilyoung.webp",
  synopsis:
    "Music documentary built around archive, biography and critical commentary.",
},
{
  role: "Producer / Director",
  title: "Katy Perry: The Girl Who Ran Away",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Aug 10 – Oct 10",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-katyperry.jpg",
  synopsis:
    "Entertainment and music documentary profiling Katy Perry’s rise and early career.",
},
{
  role: "Producer / Director",
  title: "What Ever Happened to Pink Floyd? The Strange Case of Gilmour & Waters",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Jul 10 – Aug 10",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-floyd.jpg",
  synopsis:
    "Archive-led music documentary exploring the creative tensions and legacy of Pink Floyd.",
},
{
  role: "Producer / Director",
  title: "The Sacred Triangle: Bowie, Iggy and Lou",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "May 10 – Jul 10",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-sacredtriangle.jpg",
  synopsis:
    "Archive-led documentary exploring the creative relationship between David Bowie, Iggy Pop and Lou Reed.",
},
{
  role: "Producer / Director",
  title: "Eric Clapton: The 1960s Review",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Mar 10 – May 10",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-clapton.jpg",
  synopsis:
    "Music documentary examining Eric Clapton’s 1960s work through archive and critical analysis.",
},
{
  role: "Producer / Director",
  title: "Pearl Jam: Under Review",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Jan 10 – Mar 10",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-pearljam.jpg",
  synopsis:
    "Archive-led music documentary exploring Pearl Jam’s career, sound and influence.",
},
{
  role: "Producer / Director",
  title: "The Rolling Stones: 1969–1974 The Mick Taylor Years",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Nov 09 – Jan 10",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-rollingstones.jpg",
  synopsis:
    "Music documentary focused on The Rolling Stones during the Mick Taylor era.",
},
{
  role: "Producer / Director",
  title: "Glamourpuss: The Lady Gaga Story",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Oct 09 – Nov 09",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-gaga.jpg",
  synopsis:
    "Entertainment documentary profiling Lady Gaga’s early rise and cultural impact.",
},
{
  role: "Producer / Director",
  title: "Muse: Under Review",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Aug 09 – Oct 09",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-muse.jpg",
  synopsis:
    "Archive-led music documentary exploring Muse’s career, sound and development.",
},
{
  role: "Producer / Director",
  title: "Michael Jackson: Thank You for the Music – The Final Word",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Jun 09 – Aug 09",
  commissioner: "Rob Johnston",
  category: "Music / Archive Documentary",
  image: "/images/work-mj.jpg",
  synopsis:
    "Archive-led music documentary reflecting on Michael Jackson’s career and legacy.",
},
{
  role: "Producer / Director",
  title: "Revolution in the Head: Rage Against the Machine and the Power of Protest",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "May 09 – Jun 09",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-rage.webp",
  synopsis:
    "Archive-led music documentary exploring Rage Against the Machine, protest, politics and cultural impact.",
},
{
  role: "Producer / Director",
  title: "The Who, the Mods and the Quadrophenia Connection",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Mar 09 – May 09",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-thewho.jpg",
  synopsis:
    "Archive-led music documentary examining The Who, mod culture and the legacy of Quadrophenia.",
},
{
  role: "Producer / Director",
  title: "Pink: A Life Less Ordinary",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Feb 09 – Mar 09",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-pink.jpg",
  synopsis:
    "Music and entertainment documentary profiling Pink’s career, image and cultural presence.",
},
{
  role: "Producer / Director",
  title: "Depeche Mode: The Dark Progression",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Dec 08 – Jan 09",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-depeche.jpg",
  synopsis:
    "Archive-led music documentary exploring Depeche Mode’s sound, evolution and influence.",
},
{
  role: "Producer / Director",
  title: "Nine Inch Nails and the Industrial Uprising",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Oct 08 – Dec 08",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-nin.jpg",
  synopsis:
    "Music documentary exploring Nine Inch Nails, industrial music and the wider cultural scene around the band.",
},
{
  role: "Producer / Director",
  title: "Kate Bush: Hounds of Love – Under Review",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Aug 08 – Sep 08",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-bush.jpg",
  synopsis:
    "Archive-led music documentary looking at Kate Bush’s Hounds of Love and its creative legacy.",
},
{
  role: "Producer / Director",
  title: "Frank Zappa & the Mothers of Invention: In the 1960s",
  channel: "",
  company: "Spiritlevel Cinema",
  date: "Jul 08 – Aug 08",
  commissioner: "",
  category: "Music / Archive Documentary",
  image: "/images/work-zappa.jpg",
  synopsis:
    "Music documentary exploring Frank Zappa, The Mothers of Invention and the 1960s countercultural landscape.",
},
];